import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../context/AppContext";
import "bootstrap/dist/css/bootstrap.min.css";
import Form from "react-bootstrap/Form";
import {
  getWithAuthCallWithErrorResponse,
  postWithAuthCall,
} from "../api/ApiServices";
import ApiConfig from "../api/ApiConfig";
import { ToastMsg } from "./ToastMsg";
import Loader from "./Loader";

// Admin-editable App Store / Play Store links. The landing page reads these
// from the public GET /content/store-links endpoint.
const AppLinks = () => {
  const { sidebar } = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const [appStoreUrl, setAppStoreUrl] = useState("");
  const [playStoreUrl, setPlayStoreUrl] = useState("");

  const getLinks = () => {
    setLoading(true);
    getWithAuthCallWithErrorResponse(ApiConfig.STORE_LINKS)
      .then((res) => {
        if (!res.error && res.json?.data) {
          setAppStoreUrl(res.json.data.appStoreUrl || "");
          setPlayStoreUrl(res.json.data.playStoreUrl || "");
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const saveLinks = (event) => {
    event.preventDefault();
    postWithAuthCall(
      ApiConfig.STORE_LINKS,
      JSON.stringify({ appStoreUrl, playStoreUrl })
    )
      .then((res) => {
        if (res.error) {
          ToastMsg("error", res.json?.message || "Could not save");
        } else {
          ToastMsg("success", "Store links saved");
        }
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    getLinks();
  }, []);

  return (
    <main
      id="cx-main"
      className={sidebar ? "admin-main" : "cx-active admin-main"}
    >
      <div className="heading-btn-main">
        <div className="heading-common">
          <label htmlFor="">App Links</label>
        </div>
      </div>

      {loading ? (
        <div style={{ marginTop: "150px" }}>
          <Loader />
        </div>
      ) : (
        <div className="documents-wrapper user-details-main-card">
          <div className="user-detail-card">
            <div className="document-cards">
              <Form onSubmit={saveLinks} style={{ maxWidth: "640px" }}>
                <div className="mb-3">
                  <Form.Label>App Store URL (iOS)</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="https://apps.apple.com/app/id0000000000"
                    value={appStoreUrl}
                    onChange={(e) => setAppStoreUrl(e.target.value)}
                  />
                  <Form.Text muted>
                    Leave blank until the App Store listing exists; the landing
                    page hides the iOS badge while empty.
                  </Form.Text>
                </div>

                <div className="mb-3">
                  <Form.Label>Play Store URL (Android)</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="https://play.google.com/store/apps/details?id=co.marryem.app"
                    value={playStoreUrl}
                    onChange={(e) => setPlayStoreUrl(e.target.value)}
                  />
                </div>

                <div className="buttons-modal border-top pt-3 text-end">
                  <button type="submit">Save</button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      )}
    </main>
  );
};

export default AppLinks;
